import React from 'react';
import { FormattedMessage } from 'react-intl';

import useStatements from '../../context/statements/useStatements';
import Spinner from '../spinner/Spinner';

import StatementError from './StatementError';
import StatementItem from './StatementItem';
import StatementNotAvailable from './StatementNotAvailable';

const StatementList = (props) => {
    const { accountStatements } = useStatements();
    const { error, isFetchingStatements, listOfStatements } = accountStatements[props.accountNumber];

    if (error) {
        return <StatementError />;
    }

    if (isFetchingStatements) {
        return (
            <div className="statement-loading">
                <Spinner />
            </div>
        );
    }

    if (!listOfStatements || !props.selectedStatementsPeriod) {
        return null;
    }

    let statementList = listOfStatements['last6Months'];

    if (props.selectedStatementsPeriod === 'last6-12Months') {
        statementList = statementList.concat(listOfStatements['last6-12Months']);
    }

    if (props.selectedStatementsPeriod === 'last12-18Months') {
        statementList = statementList.concat(listOfStatements['last6-12Months'], listOfStatements['last12-18Months']);
    }

    if (props.selectedStatementsPeriod === 'last18-24Months') {
        statementList = statementList.concat(
            listOfStatements['last6-12Months'],
            listOfStatements['last12-18Months'],
            listOfStatements['last18-24Months']
        );
    }

    if (!statementList?.length) {
        return <StatementNotAvailable />;
    }

    return (
        <div className="statements-list-wrapper">
            <h3>
                <FormattedMessage id="statements.subtitle.available" />
            </h3>
            <ol className="statement-list">
                {statementList.map((statement, i) => (
                    <StatementItem key={i} statement={statement} />
                ))}
            </ol>
        </div>
    );
};
export default StatementList;
